<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a rating element that can be used with stars
    *
    * @since 20230517
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div :class="['ratingOuter', noRatings > 10 && !(onlyLabel && readOnly) ? 'slider-container' : '']">
        <div :class="[!large || noRatings > 10 ? 'rating' : '', noRatings > 10 && !(onlyLabel && readOnly) ? 'slider-container' : '']">
            <span v-if="onlyLabel && readOnly">
                {{getLabel(valueActual)}} (Predicted: {{getLabel(predictedValue)}})
            </span>
            <template v-else-if="large && noRatings <= 10">
                <button v-for="star in loopNumbers" :key="star" type="button" :class="['ev-btnrating btn', valueActual >= star ? 'btn-edit' : 'btn-light', 'btn-lg border mr-1']" :id="'ev-rating-star-' + star" @click="valueActual = star;updateValue();">
                    <i class="fa fa-star" aria-hidden="true"></i>
                </button>
            </template>
            <ul v-else-if="!large && noRatings <= 10">
                <li v-for="star in loopNumbers" :key="star" :class="['fa', type > 0 ? 'label' : 'fa-star', readOnly ? 'disabled' : '', extraClasses, getHoverColor(star), getRagColor(star)]" aria-hidden="true" @click="clickMethod(star)" @mouseover="hoverMethod(star)"  @mouseleave="unhoverMethod(star)">
                    <input v-if="readOnly" disabled type="radio" :name="name" :id="name + '-star-' + star" :value="star" v-model="valueActual" @change="updateValue()" />
                    <input v-else disabled type="radio" :name="name" :id="name + '-star-' + star" :value="star" v-model="valueActual" @change="updateValue()" />
                    <label :for="name + '-star-' + star">{{getLabel(star)}}</label>
                </li>
            </ul>
            <vue-slider v-else 
                width="100%" 
                :direction="reverse ? 'rtl' : 'ltr'" 
                :tooltip-formatter="toolTipFormat"
                :marks="sliderMarks" 
                :min="1" 
                :max="noRatings" 
                :drag-on-click="true"
                tooltip="always"
                :disabled="readOnly"
                v-model="valueActual" 
                @change="updateValue()"
            ></vue-slider>
        </div>
        <i v-if="!onlyLabel || !readOnly" @click="valueActual = -1;updateValue();" :class="['ratingReset']"><br />&nbsp;&nbsp;&nbsp;&nbsp;Reset</i>
    </div>
</template>

<script>
    export default{
        props: {
            //the name of the date picker
            name: {
                type: String,
                default: 'rating'
            },
            //the default number of ratings
            noRatings: {
                type: Number,
                default: 5
            },
            //the value
            value: {
                type: String|Number,
                default: 1
            },
            predictedValue: {
                type: String|Number,
                default: -1
            },
            ragValues: {
                type: Object,
            },
            justHighlightSelected: {
                type: Boolean,
                default: false
            },
            extraClasses: {
                type: String,
                default: ''
            },
            readOnly: {
                type: Boolean,
                default: false
            },
            //0 for star, 1 for number, 2 for Grade, 3 numeric with +-, 4 grade with +-, 5 level, 6 custom
            type: {
                type: Number,
                default: 0
            },
            customLabels: {
                type: Array
            },
            reverse: {
                type: Boolean,
                default: false
            },
            onlyLabel: {
                type: Boolean,
                default: false
            },
            large: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            
        },
        data() {
            return {
                //the date
                valueActual: this.value,
                hoverValue: -1,
            }
        },
        computed: {
            loopNumbers: function(){
                if(this.reverse){
                    var nums = [];
                    for(var i=this.noRatings; i>0; i--){
                        nums.push(i);
                    }
                    return nums;
                } else {
                    var nums = [];
                    for(var i=1; i<=this.noRatings; i++){
                        nums.push(i);
                    }
                    return nums;
                }
            },
            sliderData: function(){
                if(this.type == 2){
                    if(this.reverse){
                        return ['G', 'F', 'E', 'D', 'C', 'B', 'A'];
                    } else {
                        return ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
                    }
                } else if(this.type == 4){
                    if(this.reverse){
                        return ['G-', 'G', 'G+', 'F-', 'F', 'F+', 'E-', 'E', 'E+', 'D-', 'D', 'D+', 'C-', 'C', 'C+', 'B-', 'B', 'B+', 'A-', 'A', 'A+'];
                    } else {
                        return ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'E+', 'E', 'E-', 'F+', 'F', 'F-', 'G+', 'G', 'G-'];
                    }
                } else {
                    return undefined;
                }
            },
            sliderMarks: function(){
                if(this.type == 2){
                    return {
                        1: this.getLabel(1), 
                        2: this.getLabel(2), 
                        3: this.getLabel(3),
                        4: this.getLabel(4),
                        5: this.getLabel(5),
                        6: this.getLabel(6),
                        7: this.getLabel(7)
                    };
                } else if(this.type == 4 || this.type == 3){
                    return {
                        2: this.getLabel(2), 
                        5: this.getLabel(5), 
                        8: this.getLabel(8),
                        11: this.getLabel(11),
                        14: this.getLabel(14),
                        17: this.getLabel(17),
                        20: this.getLabel(20),
                        21: this.getLabel(21)
                    };
                } else {
                    var ob = {
                        1: this.getLabel(1), 
                    };
                    var denom = 5;
                    if(this.noRatings > 30){
                        denom = 10;
                    }
                    for(var i=denom; i<this.noRatings; i+=denom){
                        ob[i] = this.getLabel(i);
                    }
                    ob[this.noRatings] = this.getLabel(this.noRatings);
                    return ob;
                }
            }
        },
        methods: {
            toolTipFormat: function(value){
                return this.getLabel(value);
            },
            clickMethod: function(star){
                if(!this.readOnly){
                    this.valueActual = star;
                    this.updateValue();
                }
            },
            hoverMethod: function(star){
                if(!this.readOnly){
                    this.hoverValue = star;
                }
            },
            unhoverMethod: function(star){
                this.hoverValue = -1;
            },
            getLabel: function(star){
                if(this.type == 5){
                    return 'L' + star;
                } else if(this.type == 6){
                    return this.customLabels[(star-1)%this.customLabels.length];
                } else if(this.type == 2 || this.type == 4){
                    var grades = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
                    if(this.type == 4){
                        var gradePos = Math.ceil((this.noRatings-(star-1))/3)-1;
                        var plusMinus = star%3 == 0 ? '+' : (star%3 == 2 ? '' : '-');
                        return gradePos < grades.length && gradePos >= 0 ? grades[gradePos] + plusMinus : 'A' + plusMinus;
                    } else {
                        var gradePos = this.noRatings-star;
                        return gradePos < grades.length && gradePos >= 0 ? grades[gradePos] : 'A';
                    }
                } else if(this.type == 3){
                    var gradePos = Math.ceil(star/3);
                    var plusMinus = star%3 == 0 ? '+' : (star%3 == 2 ? '' : '-');
                    return gradePos + plusMinus;
                } else if(this.type == 0 && this.noRatings == 100){
                    return star + '%';
                }
                return star;
            },
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            updateValue: function (value) {
                var returnVal = this.valueActual;
                if(this.sliderData !== undefined){

                }
                this.$emit('input', this.valueActual);
                this.$emit('change', this.valueActual);
            },
            getHoverColor: function(star){
                if(!this.justHighlightSelected){
                    if(this.hoverValue > 0 && this.hoverValue < star && this.valueActual >= star){
                        return 'staroldchecked';
                    } else if(this.hoverValue >= star){
                        return 'starhovered';
                    } else if(this.valueActual >= star || this.predictedValue >= star){
                        return 'starchecked';
                    }
                } else {
                    if(this.hoverValue > 0 && this.hoverValue != star && this.valueActual == star){
                        return 'staroldchecked';
                    } else if(this.hoverValue > 0 && this.hoverValue == star){
                        return 'starhovered';
                    } else if(this.valueActual == star){
                        return 'starchecked';
                    }
                }
                return '';
            },
            getRagColor: function(star){
                if(!this.justHighlightSelected){
                    if(this.predictedValue >= 0){
                        if(this.predictedValue < this.valueActual && star > this.predictedValue && (this.valueActual >= star || this.predictedValue >= star)){
                            return 'text-success';
                        }
                        if(this.predictedValue > this.valueActual && star > this.valueActual && (this.valueActual >= star || this.predictedValue >= star)){
                            return 'text-danger';
                        }
                    } else if(this.ragValues !== undefined){
                        /*if(this.hoverValue == star){
                            if(this.ragValues.red !== undefined && this.hoverValue <= this.ragValues.red){
                                return 'text-danger';
                            } else if(this.ragValues.green !== undefined && this.hoverValue >= this.ragValues.green){
                                return 'text-success';
                            } else {
                                return '';
                            }
                        }*/
                        var valueToUse = this.valueActual;
                        if(this.hoverValue > -1){
                            valueToUse = this.hoverValue;
                        }
                        if(valueToUse >= star){
                            if(this.hoverValue > -1 && this.hoverValue < star){
                                return '';
                            }
                            
                            if(this.ragValues.red !== undefined && valueToUse <= this.ragValues.red){
                                return 'text-danger';
                            } else if(this.ragValues.green !== undefined && valueToUse >= this.ragValues.green){
                                return 'text-success';
                            }
                        }
                    }
                } else {
                    if(this.hoverValue > 0 && this.hoverValue == star){
                        if(this.ragValues.red !== undefined && this.hoverValue <= this.ragValues.red){
                            return 'text-danger';
                        } else if(this.ragValues.green !== undefined && this.hoverValue >= this.ragValues.green){
                            return 'text-success';
                        }
                    } else if(this.valueActual == star){
                        if(this.hoverValue > -1 && this.hoverValue != star){
                            return '';
                        }
                        if(this.ragValues.red !== undefined && this.valueActual <= this.ragValues.red){
                            return 'text-danger';
                        } else if(this.ragValues.green !== undefined && this.valueActual >= this.ragValues.green){
                            return 'text-success';
                        }
                    }
                }
                return '';
            }
        }
    }
</script>